import React, { useEffect, useState } from 'react';
import { motion } from 'framer-motion';
import { Menu, X, Briefcase } from 'lucide-react';
const LOGO_URL = 'https://cdn.magicpatterns.com/uploads/qtRkR6UFYwHcZHUZTWVph1/Titulo.png';
const WHATSAPP_LINK = 'https://wa.me/50689925929?text=Hola%2C%20quiero%20m%C3%A1s%20informaci%C3%B3n%20sobre%20la%20certificaci%C3%B3n%20de%20GAS%20LP%20para%20mi%20establecimiento';
const WHATSAPP_TRABAJO = 'https://wa.me/50689925929?text=%C2%A1Quiero%20trabajar%20con%20Jazuga!';
export function Header() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  return <motion.header initial={{
    y: -100
  }} animate={{
    y: 0
  }} className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-md shadow-lg' : 'bg-transparent'}`} data-id="element-101">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-102">
        <div className="flex items-center justify-between h-20" data-id="element-103">
          {/* Logo */}
          <a href="#" className="flex-shrink-0" data-id="element-104">
            <img src={LOGO_URL} alt="Jazugas - Ingeniería Electromecánica" className={`h-16 w-auto transition-all duration-300 ${isScrolled ? '' : 'brightness-0 invert'}`} data-id="element-105" />
          </a>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-106">
            <a href="#beneficios" className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#1e3a5f]' : 'text-white/90 hover:text-white'}`} data-id="element-107">
              Beneficios
            </a>
            <a href="#proceso" className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#1e3a5f]' : 'text-white/90 hover:text-white'}`} data-id="element-108">
              Proceso
            </a>
            <a href="#testimonios" className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#1e3a5f]' : 'text-white/90 hover:text-white'}`} data-id="element-109">
              Testimonios
            </a>
            <a href="#faq" className={`font-medium transition-colors ${isScrolled ? 'text-gray-700 hover:text-[#1e3a5f]' : 'text-white/90 hover:text-white'}`} data-id="element-110">
              FAQ
            </a>
          </nav>

          {/* Desktop CTA Buttons */}
          <div className="hidden md:flex flex-col items-end gap-1.5" data-id="element-111">
            <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="px-6 py-2.5 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg shadow-md hover:shadow-lg transition-all transform hover:-translate-y-0.5 inline-block" data-id="element-112">
              Certificar Ahora
            </a>
            <a href={WHATSAPP_TRABAJO} target="_blank" rel="noopener noreferrer" className="px-4 py-1.5 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-md shadow-sm hover:shadow-md transition-all flex items-center gap-1.5 text-sm" data-id="element-113">
              <Briefcase className="w-3.5 h-3.5" data-id="element-114" />
              Trabaja con Nosotros
            </a>
          </div>

          {/* Mobile: Trabaja con Nosotros + Menu Button */}
          <div className="md:hidden flex items-center gap-2" data-id="element-115">
            <a href={WHATSAPP_TRABAJO} target="_blank" rel="noopener noreferrer" className="px-3 py-1.5 bg-green-500 hover:bg-green-600 text-white font-semibold rounded-md shadow-sm transition-all flex items-center gap-1.5 text-xs" data-id="element-116">
              <Briefcase className="w-3.5 h-3.5" data-id="element-117" />
              Trabaja con Nosotros
            </a>
            <button onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} className={`p-2 rounded-lg transition-colors ${isScrolled ? 'text-gray-700' : 'text-white'}`} data-id="element-118">
              {isMobileMenuOpen ? <X className="w-6 h-6" data-id="element-119" /> : <Menu className="w-6 h-6" data-id="element-120" />}
            </button>
          </div>
        </div>

        {/* Mobile Menu */}
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        y: -10
      }} animate={{
        opacity: 1,
        y: 0
      }} className="md:hidden bg-white rounded-xl shadow-xl mt-2 p-4 absolute left-4 right-4" data-id="element-121">
            <div className="flex justify-center mb-4 pb-4 border-b border-gray-100" data-id="element-122">
              <img src={LOGO_URL} alt="Jazugas" className="h-16 w-auto" data-id="element-123" />
            </div>
            <nav className="flex flex-col gap-4" data-id="element-124">
              <a href="#beneficios" className="text-gray-700 font-medium py-2 hover:text-[#1e3a5f]" data-id="element-125">
                Beneficios
              </a>
              <a href="#proceso" className="text-gray-700 font-medium py-2 hover:text-[#1e3a5f]" data-id="element-126">
                Proceso
              </a>
              <a href="#testimonios" className="text-gray-700 font-medium py-2 hover:text-[#1e3a5f]" data-id="element-127">
                Testimonios
              </a>
              <a href="#faq" className="text-gray-700 font-medium py-2 hover:text-[#1e3a5f]" data-id="element-128">
                FAQ
              </a>
              <a href={WHATSAPP_LINK} target="_blank" rel="noopener noreferrer" className="w-full px-6 py-3 bg-[#f59e0b] hover:bg-[#d97706] text-white font-bold rounded-lg shadow-md mt-2 text-center" data-id="element-129">
                Certificar Ahora
              </a>
              <a href={WHATSAPP_TRABAJO} target="_blank" rel="noopener noreferrer" className="w-full px-6 py-3 bg-green-500 hover:bg-green-600 text-white font-bold rounded-lg shadow-md text-center flex items-center justify-center gap-2" data-id="element-130">
                <Briefcase className="w-4 h-4" data-id="element-131" />
                Trabaja con Nosotros
              </a>
            </nav>
          </motion.div>}
      </div>
    </motion.header>;
}